import WebshareApi from "../api";

export type WebshareFetcherOptions = {
  url: string;
  subUserId?: string;
  apiVersion?: "v2" | "v3";
};

export const fetcher = (params: WebshareFetcherOptions) => {
  const { url, subUserId, apiVersion } = params;

  // This only sets subuser for this one request.
  // If you want to set subuser for all requests, you can use WebshareApi.setSubuserHeader(subUserId)
  if (subUserId) {
    const token = WebshareApi.getAuthToken();
    return WebshareApi.get(url, {
      headers: { Authorization: `Token ${token}`, "X-Subuser": subUserId },
      apiVersion,
    }).then((res) => res.data);
  }

  return WebshareApi.get(url, { apiVersion }).then((res) => res.data);
};
